import React, { useEffect, useState } from "react";
import tz from "moment-timezone";
import moment from "moment";
import "moment/locale/ne";
import TimeContext from "../timecontext/TimeContext";

function TimeProvider({ children }) {
  const [nepalIntervalTime, setNepalIntevalTime] = useState("");

  useEffect(() => {
    setInterval(() => {
      const nepalTime = moment().tz("Asia/Kathmandu").format("LTS");
      setNepalIntevalTime(`KTM - ${nepalTime}`);
    }, 1000);
  }, []);

  const isStoreClosed = () => {
    let currentTime = moment().tz("Asia/Kathmandu");

    //let currentTime = moment(`2020-09-16, 16:00:00`, "YYYY-MM-DD, h:mm:ss a");

    const year = currentTime.format("YYYY");
    const month = currentTime.format("MM");
    const date = currentTime.format("DD");

    currentTime = moment(
      `${year}-${month}-${date}, ${currentTime.format(
        "HH"
      )}:${currentTime.format("mm")}:${currentTime.format("ss")}`,
      "YYYY-MM-DD, h:mm:ss a"
    );

    const startTime = moment(
      `${year}-${month}-${date}, 10:00:00`,
      "YYYY-MM-DD, h:mm:ss a"
    );

    const endTime = moment(
      `${year}-${month}-${date}, 19:00:00`,
      "YYYY-MM-DD, h:mm:ss a"
    );

    if (currentTime.isAfter(startTime) && currentTime.isBefore(endTime)) {
      return true;
    }
    return false;
  };

  return (
    <div>
      <TimeContext.Provider value={{ nepalIntervalTime, isStoreClosed }}>
        {children}
      </TimeContext.Provider>
    </div>
  );
}

export default TimeProvider;
